import { OWebApp } from "oweb";
import { SXCompany } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class CompaniesStore extends ServiceStore<SXCompany> {

	constructor(app: OWebApp) {
		super(app, SXCompany, "companies");
	}
}
